/* @flow strict */

import * as React from 'react';
import {
  RoutesType
} from 'client/src/routes';
import PayoutsPage from './index';

export const PayoutsRoutes: RoutesType = [{
  Component: PayoutsPage,
  params: {
    path: '/pay/:viewTab?'
  }
}];
